
export const FETCH_BUTTON_CLICKED = "FETCH_BUTTON_CLICKED";
export const BANK_LIST = "BANK_LIST";